import Popover from 'antd/lib/popover';
import React from 'react';
import { PatternToken } from '../../types';
import { PatternTokenHelperTextComponent } from '../appSettings/PatternTokenHelperTextComponent';
import { antGrey } from '../styles/globalStyles';
import { InfoCircleOutlined } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';

const SupportedTokensComponent: React.FC<{ availableTokens?: PatternToken[]; prefixText?: string }> = ({
    availableTokens,
    prefixText,
}) => {
    const defaultAvailableTokens: PatternToken[] = [
        PatternToken.Version,
        PatternToken.VersionConcise,
        PatternToken.VersionMajorMinor,
        PatternToken.ReleaseName,
        PatternToken.BuildAppStore,
        PatternToken.BuildCI,
        PatternToken.ReleaseBranchName,
        PatternToken.AppPlatform,
    ];

    return (
        <Text style={{ color: antGrey.grey7 }}>
            {prefixText ? `${prefixText} ` : ''}Tokens are supported{' '}
            <Popover
                content={
                    <PatternTokenHelperTextComponent availableTokens={availableTokens ?? defaultAvailableTokens} />
                }
            >
                <InfoCircleOutlined style={{ color: antGrey.grey7 }} />
            </Popover>
        </Text>
    );
};

export default SupportedTokensComponent;
